import { useSuspenseQuery } from '@apollo/client';
import { gql } from '@/__generated__';

export const StreamPostsQuery = gql(`
  query StreamPostsQuery($id: ID!, $limit: Int!, $nextToken: String) {
    streamPosts(id: $id, limit: $limit, nextToken: $nextToken) {
      items {
        ... on StreamPost {
          ...StreamPostCardFragment
        }
      }
      nextToken
    }
  }
  `);

export const useStreamPosts = (id: string) => {
  return useSuspenseQuery(StreamPostsQuery, {
    variables: {
      id,
      limit: 20,
      nextToken: null,
    },
    fetchPolicy: 'cache-and-network',
  });
};
